module.exports = __webpack_public_path__ + "media/images/banner-9577486d8810b8ae78731416885c4eb9.jpeg";